import { getRange } from 'utils/section/gridUtils';
import type { TemplateFormsState } from '../index';
import type { LayoutType, TemplateSectionItem } from 'types';

interface Payload {
  focusedSectionName: string | null;
  position: {
    x: number;
    y: number;
  };
  layoutType: LayoutType;
  data: TemplateSectionItem;
  subTabId?: string | null;
}

export const updateSectionItem = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { focusedSectionName, position, layoutType, data, subTabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = sections.findIndex((section) => section.name === focusedSectionName);
  if (sectionIndex === -1) return;

  const section = sections[sectionIndex];

  const targetX = position.x;
  const targetY = position.y;

  state[layoutType].sections[sectionIndex].items = section.items.map((item) => {
    const itemSubTab = item.subTabId ?? null;
    const targetSubTab = subTabId ?? null;
    if (itemSubTab !== targetSubTab) return item;

    const { start: xStart, end: xEnd } = getRange(item.x);
    const { start: yStart, end: yEnd } = getRange(item.y);
    if (targetX >= xStart && targetX <= xEnd && targetY >= yStart && targetY <= yEnd) {
      return {
        ...data,
        subTabId: data.subTabId !== undefined ? data.subTabId : item.subTabId,
      };
    }
    return item;
  });
};
